export default {

    methods: {
        closeModal(id) {
            $(`#${id}`).modal('hide');
        },
        getCustomModalId(name,id) {
            return `${name}-${id}`
        },
        showCustomModal(name, id) {
            $(`#${name}-${id}`).modal()
        },

        getModalId(id) {
            return `modalId-${id}`
        },
        showModal(id) {
            $(`#modalId-${id}`).modal()
        },

        getDeleteModalId(id, section='delete') {
            return `deleteModalId-${section}-${id}`
        },
        showDeleteModal(id, section='delete') {
           return $(`#deleteModalId-${section}-${id}`).modal()
        },

        reloadPage() {
            return window.location.reload();
        },
        backToPreviousPage() {
           return window.history.back()
        }

    }
}
